import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const PROGRESS_DIALOG_ENABLED_FIELD = 'settings.siteSettingsV2.progressDialogEnabled';
export const PROGRESS_DIALOG_SECTION_NAME = 'progressDialog';
export const PROGRESS_DIALOG_PREFIX = 'settings.siteSettingsV2';

export type ProgressDialogSectionProps = SiteSettingsForSiteAdminProps<'siteSettingsV2'>;

export function ProgressDialogSection(): React.ReactElement | null {
  if (!FeatureFlags.enableConfigurableProgressDialogEnabled) {
    return null;
  }

  if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return (
      <SettingsSection
        title={Messages.progressDialog()}
        testId={'progress-dialog-setting-section'}>
        <MetadataDrivenSiteSettings
          sectionName={PROGRESS_DIALOG_SECTION_NAME}
          formikPrefix={PROGRESS_DIALOG_PREFIX} />
      </SettingsSection>
    );
  }

  return (
    <SettingsSection
      title={Messages.progressDialog()}
      description={Messages.progressDialogEnabledDescription()}
      testId={'progress-dialog-setting-section'}>
      <FormikCheckbox
        name={PROGRESS_DIALOG_ENABLED_FIELD}
        label={Messages.progressDialogEnabledLabel()}
        testId={'progress-dialog-enabled'} />
    </SettingsSection>
  );
}

export const ProgressDialogSectionSpecs = componentRegistryEntry({
  name: 'ProgressDialogSection',
  component: ProgressDialogSection
});
